"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInputStyles = exports.createStyles = exports.Radio = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../styles");
var Input_1 = require("../Input");
function Radio(props) {
    var label = props.label, style = props.style, rest = __rest(props, ["label", "style"]);
    var classes = styles_1.useStyles(exports.createStyles).classes;
    var _a = styles_1.useStyles(exports.createInputStyles, classes), inputClasses = _a.classes, css = _a.css;
    return (react_1.default.createElement("label", { className: classes.wrapper },
        react_1.default.createElement(Input_1.Input, __assign({}, rest, { type: 'radio', className: css(inputClasses.input, style) })),
        react_1.default.createElement("span", { className: classes.radio }),
        react_1.default.createElement("span", { className: classes.label }, label)));
}
exports.Radio = Radio;
exports.createStyles = function (theme) { return ({
    wrapper: {
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
    },
    radio: {
        backgroundColor: theme.pallete.surface.main,
        border: '1px solid ' + theme.pallete.gray.c60,
        borderRadius: 100,
        display: 'inline-block',
        height: 24,
        position: 'relative',
        transition: 'all .2s ease',
        verticalAlign: 'middle',
        width: 24,
        ':after': {
            backgroundColor: theme.pallete.surface.main,
            border: '5px solid ' + theme.pallete.surface.main,
            borderRadius: 100,
            content: '""',
            display: 'block',
            height: 2,
            marginLeft: 6,
            marginTop: 6,
            opacity: 0,
            textAlign: 'center',
            transition: 'all .2s ease',
            width: 2,
        },
    },
    label: {
        marginLeft: '0.5rem',
    },
}); };
exports.createInputStyles = function (theme, classes) {
    var _a;
    return ({
        input: (_a = {
                opacity: 0,
                marginRight: -13
            },
            _a["&:hover + ." + classes.radio] = {
                borderColor: theme.pallete.gray.c50,
            },
            _a["&:checked + ." + classes.radio] = {
                backgroundColor: theme.pallete.primary.main,
                borderColor: theme.pallete.primary.main,
                ':after': {
                    opacity: 1,
                },
            },
            _a["&:focus + ." + classes.radio] = {
                boxShadow: styles_1.focusBoxShadow(theme),
            },
            _a["&:disabled + ." + classes.radio] = {
                opacity: 0.4,
                cursor: 'not-allowed',
            },
            _a["&:disabled + ." + classes.radio + " + ." + classes.label] = {
                color: theme.pallete.gray.c70,
                cursor: 'not-allowed',
            },
            _a),
    });
};
//# sourceMappingURL=Radio.js.map